import { hideLimitOverlay, showLimitOverlay } from "./content-account-gate.js";

$(document).ready(function() {
  var $el = $('#svPlayerId');
  var classMap = {
    'document': 'document_player',
    'html': 'html_player',
    'infographic': 'infographic_player',
    'video': 'video_player'
  };
  const slideshare_object = window.slideshare_object;

  const showOrHideOverlayWhenSlideChange = (index, compareSlideIndex) => {
    const shouldBlurReader = $('.player').attr('data-shouldblurreader');

    if (index === compareSlideIndex && shouldBlurReader) {
      hideLimitOverlay();
    }
        
    if (index > compareSlideIndex && shouldBlurReader) {
      showLimitOverlay();
    }
  };
  
  /*eslint-disable */
  const player = new SSPlayer(slideshare_object.jsplayer);
  /*eslint-enable */
  $(player).bind('slidechanged', function(e) {
    const loadDataForSlide = window.loadDataForSlide;
    if (typeof(loadDataForSlide) === 'function') {
      loadDataForSlide(e.ssData.index);
    }

    /**
     * To handle current slide position starting with 0 on mobile & 1 on desktop
     */
    if (window.innerWidth <= 928) {
      showOrHideOverlayWhenSlideChange(e.ssData.index, 0);
    } else {
      showOrHideOverlayWhenSlideChange(e.ssData.index, 1);
    }
  });

  $el.addClass(classMap[player.config.player_type]);
});
